import { UserType } from "../state/UserState";
const currentEnv = process.env.NODE_ENV ?? "development";
class UserStore {
  STORAGE_KEY = currentEnv + "ok2pUser";

  getUser() {
    let user = localStorage.getItem(this.STORAGE_KEY);
    if (user === null) return null;
    return JSON.parse(user);
  }
  storeUser(user: UserType) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(user));
  }
  clearStore() {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}

export default new UserStore();
